export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/mohagni.5b32ffca.svg","height":20,"width":68,"blurWidth":0,"blurHeight":0};